export const getShortDate = (dateEntered) => {
  const date = new Date(dateEntered);
  let monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];
	let day = date.getUTCDate();
	let monthIndex = date.getUTCMonth();
	let monthName = monthNames[monthIndex];
	let year = date.getFullYear();
	return `${day} ${monthName} ${year}`;
}